export default [
  {
    title: '管理者マイページ',
    icon: 'icon-home',
    routes: [
      {
        path: '/',
        component: 'Home'
      }
    ]
  },
  {
    title: 'メダル管理',
    icon: 'icon-member',
    routes: [
      {
        path: '/medal',
        component: 'Medal'
      },
      {
        path: '/medal/bulk-update',
        component: 'MedalBulkUpdate'
      }
    ]
  },
  {
    title: '楽曲一覧',
    icon: 'icon-music',
    routes: [
      {
        path: '/music',
        component: 'Music'
      },
      {
        title: 'NL検索(β)',
        path: '/song/nl-search',
        component: 'SongNlSearch'
      },
      {
        title: '検索ログ(β)',
        path: '/search-log',
        component: 'SearchLogList'
      },
      {
        title: '楽曲新規登録',
        path: '/music/new/',
        component: 'MusicNew'
      },
      {
        title: '楽曲を編集',
        path: '/music/edit/marker',
        component: 'MusicEditMarker'
      },
      {
        path: ['/music/new/confirm', '/music/edit/confirm'],
        component: 'MusicConfirm'
      },
      {
        title: '楽曲を編集',
        path: '/music/edit/:id',
        component: 'MusicEdit'
      },
      {
        title: '楽曲詳細',
        path: ['/music/detail/:id'],
        component: 'MusicDetail'
      },
      {
        path: '/music/finish/:type',
        component: 'MusicFinish'
      },
      {
        path: '/music/bulk-update',
        component: 'MusicBulkUpdate'
      },
    ]
  },
  {
    title: '会員一覧',
    icon: 'icon-member',
    routes: [
      {
        path: '/member/',
        component: 'Member'
      },
      {
        path: '/member/detail/:id',
        component: 'MemberDetail'
      },
      {
        path: '/member/point/:id',
        component: 'MemberPoint'
      },
      {
        path: '/member/edit/:id',
        component: 'MemberEdit'
      },
      {
        path: '/member/bulk-update',
        component: 'MemberBulkUpdate'
      },
      {
        path: '/member/new',
        component: 'MemberNew'
      }
    ]
  },
  {
    title: '管理者一覧',
    icon: 'icon-employee',
    routes: [
      {
        path: '/employee',
        component: 'Employee'
      },
      {
        path: '/employee/edit/:id',
        component: 'EmployeeEdit'
      },
      {
        path: '/employee/confirm/:id',
        component: 'EmployeeConfirm'
      },
      {
        path: '/employee/new',
        component: 'EmployeeNew'
      },
      {
        path: '/employee/password/:id',
        component: 'EmployeePassword'
      },
      {
        path: '/employee/detail/:id',
        component: 'EmployeeDetail'
      }
    ]
  },
  {
    title: 'ポイント付与履歴',
    icon: 'icon-point',
    routes: [
      {
        path: '/point',
        component: 'Point'
      }
    ]
  },
  {
    title: 'おすすめ管理',
    icon: 'icon-recommend',
    routes: [
      {
        path: '/recommendalbum',
        component: 'RecommendAlbum'
      }
    ]
  },
  {
    title: 'ユーザタグ管理',
    routes: [
      {
        path: '/songTag/manage',
        component: 'SongTagManage'
      },
      {
        path: '/songTag/detail/:id',
        component: 'SongTagDetail'
      },
      {
        path: '/songTag/master',
        component: 'TagMasterManage'
      }
    ]
  },
  {
    title: '楽曲購入一覧',
    icon: 'icon-purchase',
    routes: [
      {
        path: '/purchases',
        component: 'PurchaseAggregate'
      }
    ]
  },
  {
    title: 'お知らせ管理',
    icon: 'icon-news',
    routes: [
      {
        path: '/news/edit',
        component: 'NewsEdit'
      }
    ]
  },
  {
    title: 'メール管理',
    routes: [
      {
        path: '/mail',
        component: 'MailManage'
      }, {
        path: '/mail/confirm',
        component: 'MailConfirm'
      }, {
        path: '/mail/finish',
        component: 'MailFinish'
      }, {
        path: '/mail/history',
        component: 'MailHistory'
      }
    ]
  },
  {
    title: 'Playlist',
    routes: [
      {
        path: '/playlist',
        component: 'PlaylistManage'
      }, {
        path: '/playlist/:id(\\d+)',
        component: 'PlaylistDetail'
      }, {
        path: [ '/playlist/edit/:id(\\d+)', '/playlist/new' ],
        component: 'PlaylistEdit'
      }
    ]
  },
  {
    title: '問い合わせ一覧',
    routes: [
      {
        path: '/inquiry',
        component: 'Inquiry'
      }
    ]
  },
  {
    title: '問い合わせ詳細',
    routes: [
      {
        path: '/inquiry/:id',
        component: 'InquiryDetail'
      }
    ]
  },
  {
    title: 'オープンチャット管理',
    routes: [
      {
        name: 'OpenChat',
        path: '/openchat',
        component: 'OpenChat'
      }
    ]
  },
  {
    title: 'アーティスト管理',
    routes: [
      {
        title: 'アーティスト管理',
        path: '/creator',
        component: 'Creator'
      },
      {
        title: 'アーティスト登録',
        path: '/creator/new',
        component: 'CreatorNew'
      },
      {
        title: 'アーティスト詳細',
        path: '/creator/edit/:id',
        component: 'CreatorEdit'
      }
    ]
  },
  {
    title: 'アルバム一覧',
    routes: [
      {
        path: '/album',
        component: 'Album'
      }
    ]
  },
  {
    title: '表示順管理',
    routes: [
      {
        path: '/display-order',
        component: 'DisplayOrderManage'
      }
    ]
  },
  {
    title: 'シリーズ管理',
    routes: [
      {
        path: '/series',
        component: 'SeriesManage'
      }
    ]
  },
];
